/****************** UNIFIED CART SCRIPT - FIXED ******************/
console.log('🔵 Unified cart script starting...');

(function() {
    // ══════════════════════════════════════════════════════════════
    // CONFIGURATION
    // ══════════════════════════════════════════════════════════════
    
    const INCENTIVE_THRESHOLD = 8000; // $80.00
    
    const GIFT_RULES = [
        { name: "Free Soursop Capsules", giftVariantId: 42257927635015, productIds: [7358996742215] },
        { name: "Guide A", giftVariantId: 42068414595143, productIds: [7086530494535, 7272053538887, 7358996742215] },
        { name: "Guide B", giftVariantId: 42082729427015, productIds: [7218537791559] },
        { name: "Guide C", giftVariantId: 42083067723847, productIds: [6983979106375, 7086540128327, 7110409191495, 7169355513927, 7238268682311, 7267203350599, 7339447746631, 7294284628039, 7311394013255] },
    ];
    
    const SPEND_THRESHOLD_GIFTS = [
      //  { name: "Free Turmeric Bitters", giftVariantId: 41855652888647, threshold: 8900 } // $89.00
    ];
    
    const ALL_GIFT_IDS = new Set([
        ...GIFT_RULES.map(r => r.giftVariantId),
        ...SPEND_THRESHOLD_GIFTS.map(r => r.giftVariantId)
    ]);
    
    // ══════════════════════════════════════════════════════════════
    // STATE - Prevent duplicate processing
    // ══════════════════════════════════════════════════════════════
    
    let isProcessing = false;
    let pendingUpdate = null;
    let lastProcessedItemCount = -1;
    let lastProcessedTotal = -1;
    let selfTriggered = false;
    let cartCache = null;
    let cacheTime = 0;
    
    // ══════════════════════════════════════════════════════════════
    // CACHED CART FETCH - Prevents duplicate /cart.js calls
    // ══════════════════════════════════════════════════════════════
    
    async function getCart(maxAge = 500) {
        const now = Date.now();
        if (cartCache && (now - cacheTime) < maxAge) {
            console.log('📦 Using cached cart');
            return cartCache;
        }
        
        const cart = await fetch('/cart.js').then(r => r.json());
        cartCache = cart;
        cacheTime = now;
        return cart;
    }
    
    function invalidateCache() {
        cartCache = null;
        cacheTime = 0;
    }
    
    // ══════════════════════════════════════════════════════════════
    // PROGRESS BAR - No network, instant update
    // ══════════════════════════════════════════════════════════════
    
    function updateProgressBar(cart) {
        const bar = document.querySelector('#progressive-incentive-bar');
        if (bar) bar.hidden = true;
        return;
    }
    
    // ══════════════════════════════════════════════════════════════
    // GIFT LOGIC - Calculate what needs to change
    // ══════════════════════════════════════════════════════════════
    
    function calculateGiftChanges(cart) {
        const needed = new Set();
        const inCart = new Map();
        
        // What gifts are currently in cart?
        for (const item of cart.items) {
            if (ALL_GIFT_IDS.has(item.variant_id)) {
                inCart.set(item.variant_id, item.key);
            }
        }
        
        // Calculate cart total EXCLUDING gift items
        const qualifyingTotal = cart.items
            .filter(item => !ALL_GIFT_IDS.has(item.variant_id))
            .reduce((sum, item) => sum + item.final_line_price, 0);
        
        // Check spend threshold gifts (like Free Turmeric Bitters at $89+)
        for (const rule of SPEND_THRESHOLD_GIFTS) {
            if (qualifyingTotal >= rule.threshold) {
                needed.add(rule.giftVariantId);
            }
        }
        
        // Check product-based subscription gifts (existing logic)
        for (const rule of GIFT_RULES) {
            const qualifies = cart.items.some(item => 
                rule.productIds.includes(item.product_id) &&
                !ALL_GIFT_IDS.has(item.variant_id) &&
                item.selling_plan_allocation
            );
            if (qualifies) needed.add(rule.giftVariantId);
        }
        
        return {
            add: [...needed].filter(id => !inCart.has(id)),
            remove: [...inCart.entries()].filter(([id]) => !needed.has(id)).map(([, key]) => key)
        };
    }

    // ══════════════════════════════════════════════════════════════
    // APPLY GIFT CHANGES - Single batch request
    // ══════════════════════════════════════════════════════════════
    
    async function applyGiftChanges({ add, remove }) {
        if (!add.length && !remove.length) return false;
        
        selfTriggered = true;
        
        try {
            // Remove first (if any)
            if (remove.length) {
                const updates = {};
                remove.forEach(key => updates[key] = 0);
                console.log(`➖ Removing ${remove.length} gift(s)`);
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                });
            }
            
            // Then add (if any) - batch into single request
            if (add.length) {
                console.log(`➕ Adding ${add.length} gift(s)`);
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 
                        items: add.map(id => ({ id, quantity: 1 }))
                    })
                });
            }
            
            invalidateCache();
            return true;
        } finally {
            // Reset flag after a delay to catch any cascade events
            setTimeout(() => { selfTriggered = false; }, 1500);
        }
    }

    // ══════════════════════════════════════════════════════════════
    // DRAWER REFRESH - Only when needed
    // ══════════════════════════════════════════════════════════════
    
    async function refreshDrawer() {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;

        console.log('🔄 Refreshing drawer...');
        
        const res = await fetch('/?section_id=cart-drawer');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        
        if (newDrawer) {
            const wasOpen = drawer.classList.contains('active') || 
                           drawer.classList.contains('is-open') ||
                           drawer.hasAttribute('open');
            
            drawer.innerHTML = newDrawer.innerHTML;
            
            // Re-attach overlay click listener lost during innerHTML replacement
            const overlay = drawer.querySelector('#CartDrawer-Overlay');
            if (overlay) {
                overlay.addEventListener('click', () => drawer.close());
            }
            
            // Preserve open state
            if (wasOpen) {
                drawer.classList.add('active', 'is-open');
                drawer.setAttribute('open', '');
            }
        }
        
        // Update cart count bubble
        const newCount = doc.querySelector('.cart-count-bubble');
        const currCount = document.querySelector('.cart-count-bubble');
        if (newCount && currCount) currCount.innerHTML = newCount.innerHTML;

        // Update progress bar with fresh data
        const cart = await getCart(0); // Force fresh
        updateProgressBar(cart);
        
        console.log('✅ Drawer refreshed');
        
    }

    // ══════════════════════════════════════════════════════════════
    // MAIN UPDATE - Debounced, deduped, fast
    // ══════════════════════════════════════════════════════════════
    
    function scheduleUpdate(delay = 200) {
        if (pendingUpdate) clearTimeout(pendingUpdate);
        pendingUpdate = setTimeout(doUpdate, delay);
    }
    
    async function doUpdate() {
        // Prevent overlapping updates
        if (isProcessing) {
            console.log('⏳ Already processing, scheduling retry...');
            scheduleUpdate(300);
            return;
        }
        
        isProcessing = true;
        
        try {
            const cart = await getCart(0); // Force fresh for main update
            
            // Quick check: has cart actually changed?
            const itemCount = cart.items.length;
            const total = cart.total_price;
            
            if (itemCount === lastProcessedItemCount && total === lastProcessedTotal) {
                console.log('⏭️ Cart unchanged, skipping');
                return;
            }
            
            lastProcessedItemCount = itemCount;
            lastProcessedTotal = total;
            
            // Always update progress bar (instant, no network)
            updateProgressBar(cart);
            
            // Calculate and apply gift changes
            const changes = calculateGiftChanges(cart);
            const giftsChanged = await applyGiftChanges(changes);

            document.dispatchEvent(
                new CustomEvent('cart-refreshed', { detail: cart })
            );
            
            // Only refresh drawer if gifts actually changed
            if (giftsChanged) {
                await refreshDrawer();
            }
            
        } catch (e) {
            console.error('❌ Cart update error:', e);
        } finally {
            isProcessing = false;
        }
    }

    // ══════════════════════════════════════════════════════════════
    // FETCH INTERCEPTOR - Smarter triggering
    // ══════════════════════════════════════════════════════════════
    
    const _fetch = window.fetch;
    window.fetch = function(url, opts) {
        const promise = _fetch.call(this, url, opts);
        
        if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
            // Skip if this is our own gift operation
            if (selfTriggered) {
                console.log('🔕 Ignoring self-triggered cart change');
                return promise;
            }
            
            // Check if it's a gift variant operation
            try {
                const body = opts?.body;
                if (body) {
                    const data = JSON.parse(body);
                    const isGiftOp = data.items?.some(i => ALL_GIFT_IDS.has(i.id)) ||
                        Object.values(data.updates || {}).some((v, i, arr) => {
                            const key = Object.keys(data.updates)[arr.indexOf(v)];
                            return ALL_GIFT_IDS.has(Number(key));
                        });
                    if (isGiftOp) {
                        console.log('🔕 Ignoring gift operation');
                        return promise;
                    }
                }
            } catch (e) {}
            
            console.log('📥 Cart change detected:', url.split('/').pop());
            invalidateCache();
            promise.then(() => scheduleUpdate(250));
        }
        
        return promise;
    };

    // ══════════════════════════════════════════════════════════════
    // EVENT LISTENERS - Minimal, deduped
    // ══════════════════════════════════════════════════════════════
    
    function init() {
        console.log('📜 Gift rules active:', GIFT_RULES.map(r => r.name));
        console.log('💰 Spend threshold gifts active:', SPEND_THRESHOLD_GIFTS.map(r => `${r.name} at $${(r.threshold/100).toFixed(2)}`));
        
        // Watch for drawer open
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
            let lastState = false;
            new MutationObserver(() => {
                const isOpen = drawer.classList.contains('active') || 
                              drawer.classList.contains('is-open') ||
                              drawer.hasAttribute('open');
                if (isOpen && !lastState) {
                    console.log('🛒 Drawer opened');
                    scheduleUpdate(100);
                }
                lastState = isOpen;
            }).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
        }
        
        // Only listen to ONE theme event to avoid duplicates
        document.addEventListener('cart:refresh', () => {
            if (!selfTriggered) scheduleUpdate(200);
        });
        
        // Initial check
        scheduleUpdate(100);
    }

    // DOM Ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose for debugging
    window.cartDebug = {
        update: () => scheduleUpdate(0),
        refresh: refreshDrawer,
        getCache: () => cartCache,
        clearCache: invalidateCache
    };

})();
/****************** END UNIFIED CART SCRIPT ******************/